/**
 * A problem the server found with an object when it was saved. The text holds
 * `{{key}}` placeholders that `parameters` fills in — see `warningText` in
 * components/ValidationWarnings.tsx.
 */
export interface ValidationWarning {
  code: string
  text: string
  /** True when the warning stops the object from serving at all. */
  preventsAdServing: boolean
  parameters: Record<string, string>
}

/** A creative's line item has passed its end date, so the creative no longer serves. */
export const CREATIVE_LINE_ITEM_ENDED = 'validation.warning.creative.line.item.ended'

/** The `validationWarnings` of any API object, defaulted field by field. */
export function mapValidationWarnings(raw: unknown): ValidationWarning[] {
  if (!Array.isArray(raw)) return []
  return raw.map((w: Record<string, unknown>) => ({
    code: (w.code as string) ?? '',
    text: (w.text as string) ?? '',
    preventsAdServing: (w.preventsAdServing as boolean) ?? false,
    parameters: (w.parameters as Record<string, string>) ?? {},
  }))
}
